import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=72f51372&scoped=true&"
var script = {}
import style0 from "./Empty.vue?vue&type=style&index=0&id=72f51372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f51372",
  null
  
)

export default component.exports